import { forwardRef, type Ref, type SVGProps } from "react";
const IconLockOpenFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M9 8v6h2V8a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4 1 1 0 0 0 2 0 6 6 0 0 0-6-6h-2a6 6 0 0 0-6 6m16 6H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2m-9 12a2 2 0 0 1-2-2 2 2 0 0 1 1-1.7V19a1 1 0 0 1 2 0v3.3a2 2 0 0 1 1 1.7 2 2 0 0 1-2 2" /></svg>;
const ForwardRef = forwardRef(IconLockOpenFilledSVG);
ForwardRef.displayName = "IconLockOpenFilled";
export { ForwardRef as IconLockOpenFilled };